// Utilidad para login API
import { saveToken } from '../auth'
import { API_URL } from '../config'

export async function login(username, password) {
  try {
    const res = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    })
    if (!res.ok) throw new Error('Incorrect credentials')
    const data = await res.json()
    // El backend responde { ok: true, token: ... }
    if (data && data.token) saveToken(data.token)
    // Para compatibilidad, devolver solo el token si existe
    return data.token ? { token: data.token } : data
  } catch (e) {
    throw new Error(e.message || 'Connection error')
  }
}
